import {
    ArcElement,
    BarController,
    BarElement,
    CategoryScale,
    Chart,
    Legend,
    LinearScale,
    LineController,
    LineElement,
    PointElement,
    Title,
    Tooltip
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import React from "react";
import { Bar } from "react-chartjs-2";

Chart.register(
    BarElement,
    BarController,
    LineController,
    LineElement,
    PointElement,
    LinearScale,
    Title,
    Legend,
    CategoryScale,
    ArcElement,
    ChartDataLabels,
    Tooltip
);
function BarChart({ data }) {
    return (
        <Bar
            data={data}
            options={{
                plugins: {
                    datalabels: {
                        display: true,
                        clamp: "true",
                        color: "#FFFFFF",
                        font: {
                            weight: 600,
                            style: "Montserrat",
                        },
                    },
                    tooltip: {
                        enabled: false,
                    },
                    legend: {
                        display: true,
                        position: 'top',
                        align: "center",
                        font: {
                            color: "#43425D",
                        },
                    },
                },
                maintainAspectRatio: false,
                responsive: true,
                scales: {
                    x: {
                        display: true,
                        title: {
                            display: false,
                        },
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                        ticks: {
                            fontSize: 11,
                            fontFamily: "Montserrat",
                            fontColor: "#43425D",
                        },
                    },
                    y: {
                        display: true,
                        title: {
                            display: false,
                        },
                        grid: {
                            display: true,
                            drawBorder: false,
                        },
                        ticks: {
                            fontSize: 12,
                            fontFamily: "Montserrat",
                            fontColor: "#43425D",
                            beginAtZero: true,
                            precision: 0,
                        },
                    }
                },

            }}
        />
    );
}

export default BarChart;
